if (!window.Promise) {
  window.Promise = require('promise-polyfill')
}

Object.assign = require('object-assign')



// WEBPACK FOOTER //
// ./src/polyfills.js